import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-splash-card {
	background-image: url('/assets/images/common/wp1.jpeg');
	background-size: cover;
	background-position: center center;
	background-attachment: fixed;

	& .card {
		background: ${dt('content.background')};
		border-radius: ${dt('content.border.radius')};
		box-shadow: ${dt('appSplashCard.card.shadow')};
		overflow: hidden;
	}

	& .header {
		background: ${dt('appSplashCard.header.background')};
		padding: ${dt('appSplashCard.header.padding')};
	}

	& .display {
		color: ${dt('appSplashCard.display.color')};
		font-size: ${dt('appSplashCard.display.fontSize')};
		font-weight: ${dt('appSplashCard.display.fontWeight')};
		letter-spacing: ${dt('appSplashCard.display.letterSpacing')};
		line-height: ${dt('appSplashCard.display.lineHeight')};
	}

	& .title {
		color: ${dt('appSplashCard.title.color')};
		font-size: ${dt('appSplashCard.title.fontSize')};
		font-weight: ${dt('appSplashCard.title.fontWeight')};
		line-height: ${dt('appSplashCard.title.lineHeight')};
	}

	& .message {
		color: ${dt('appSplashCard.message.color')};
		font-size: ${dt('appSplashCard.message.fontSize')};
		line-height: ${dt('appSplashCard.message.lineHeight')};
	}
}
`;
